import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from './utils';
import './fields.css';

export const NativeSelect = React.forwardRef(({ className, children, ...props }, ref) => <div className="pegasus-native-select-wrap">
  <select ref={ref} className={cn('pegasus-native-select sc-h-11 sc-w-full sc-rounded-md sc-border sc-border-solid sc-border-border sc-bg-background sc-px-3 sc-text-sm sc-text-foreground focus-visible:sc-outline-none focus-visible:sc-ring-2 focus-visible:sc-ring-ring disabled:sc-opacity-50', className)} {...props}>{children}</select>
  <ChevronDown size={14} aria-hidden="true" />
</div>);
NativeSelect.displayName = 'NativeSelect';
